var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2381 8.40279H3.76192C3.08483 8.40279 2.71807 9.24915 3.22589 9.75697L6.9499 13.5938C7.09096 13.7631 7.28844 13.8195 7.51414 13.8195C7.71163 13.8195 7.90911 13.7631 8.05017 13.5938L11.7742 9.75697C12.282 9.24915 11.9152 8.40279 11.2381 8.40279Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2381 6.59721H3.76192C3.08483 6.59721 2.71807 5.77905 3.22589 5.27123L6.9499 1.43438C7.09096 1.2651 7.31665 1.18047 7.51414 1.18047C7.71163 1.18047 7.90911 1.2651 8.05017 1.43438L11.7742 5.27123C12.282 5.77905 11.9152 6.59721 11.2381 6.59721Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.5e51e42a8d3795b773283a1b4b5da936.svg";
export { ForwardRef as ReactComponent };